import React, { useReducer, useEffect } from 'react';
import CredencialesContext from './CredencialesContext';
import CredencialesReducer from './CredencialesReducer';
import axios from 'axios';
import { 
    DATOS_LOGIN,
    ENVIAR_LOGIN,
    ALERTA_USUARIO,
    CORREO_RECUPERAR,
    ENVIAR_RECUPERAR,
    ALERTA_RECUPERAR,
    ALERTA_RECUPERAR_STR,
    DATOS_MODIFICAR,
    ENVIAR_MODIFICAR,
    ALERTA_MODIFICAR,
    ALERTA_MODIFICAR_STR,
    ALERTA_MODIFICAR_CLASS,
    ALERTA_USUARIO_STR
} from '../../Types';

const CredencialesState = props => {

    //SE DEFINEN LOS STATE
    const initialState = {
        datos_login: [],
        enviar_login: false,
        alerta_usuario: false,
        correo_recuperar: [],
        enviar_recuperar: false,
        alerta_recuperar: false,
        alerta_recuperar_str: "",
        datos_modificar: [],
        enviar_modificar: false,
        alerta_modificar: "",
        alerta_modificar_str: false,
        alerta_modificar_class: "",
        alerta_usuario_str: ""
    }

    //crear dispatch y state
    const [state, dispatch ] = useReducer(CredencialesReducer, initialState);

    const Datos_Login_F = datos_login => {

        dispatch({
            type: DATOS_LOGIN,
            payload: datos_login
        })
    }

    const Enviar_Login_F = enviar_login => {
        dispatch({
            type: ENVIAR_LOGIN,
            payload: enviar_login
        })
    }

    const Alerta_Usuario_F = alerta_usuario =>{
        dispatch({
            type: ALERTA_USUARIO,
            payload: alerta_usuario
        })
    }

    const Correo_Recuperar_F = correo_recuperar =>{
        dispatch({
            type: CORREO_RECUPERAR,
            payload: correo_recuperar
        })
    }    

    const Enviar_Recuperar_F = enviar_recuperar =>{
        dispatch({
            type: ENVIAR_RECUPERAR,
            payload: enviar_recuperar
        })
    }

    const Alerta_Recuperar_F = alerta_recuperar =>{
        dispatch({
            type: ALERTA_RECUPERAR,
            payload: alerta_recuperar
        })
    }
    
    const Alerta_Str_F = alerta_recuperar_str =>{
        dispatch({
            type: ALERTA_RECUPERAR_STR,
            payload: alerta_recuperar_str
        })
    }
    
    const Datos_Modificar_F = datos_modificar =>{
        dispatch({
            type: DATOS_MODIFICAR,
            payload: datos_modificar
        })
    }

    const Enviar_Modificar_F = enviar_modificar =>{
        dispatch({
            type: ENVIAR_MODIFICAR,
            payload: enviar_modificar
        })
    }

    const Alerta_Modificar_F = alerta_modificar =>{
        dispatch({
            type: ALERTA_MODIFICAR,
            payload: alerta_modificar
        })
    }

    const Alerta_Modificar_Str_F = alerta_modificar_str =>{
        dispatch({
            type: ALERTA_MODIFICAR_STR,
            payload: alerta_modificar_str
        })
    }

    const Alerta_Modificar_Class_F = alerta_modificar_class =>{
        dispatch({
            type: ALERTA_MODIFICAR_CLASS,
            payload: alerta_modificar_class
        })
    }

    const Alerta_Usuario_Str_F = alerta_usuario_str =>{
        dispatch({
            type: ALERTA_USUARIO_STR,
            payload: alerta_usuario_str
        })
    }

    // const path = window.location.pathname;
    const usuario = localStorage.getItem('usuario')
    const token_access = localStorage.getItem('token_access')
    
//ENVIAR LOGIN
useEffect(() => {

    const dataForm = new FormData();
    dataForm.append('username', state.datos_login.usuario);
    dataForm.append('password', state.datos_login.password);

    const EnviarLogin = async () => {

    try {
        
        const url = process.env.REACT_APP_LOCAL+'credenciales/token/';
        const respuesta = await axios.post(url, dataForm);
        
        if(respuesta.status === 200){
            const tokenacces = respuesta.data.access
            localStorage.setItem('token_access', tokenacces)

            const urlogin = process.env.REACT_APP_LOCAL+'credenciales/verificar/'
            const respuestalogin = await axios.post(urlogin, dataForm,{
                headers: { 
                    Authorization: "Bearer " + tokenacces,
                    accept: 'application/json', }
            });
            
            localStorage.setItem('apikey', respuestalogin.data.apikey)
            if(respuestalogin.status === 200){
                localStorage.setItem('usuario', state.datos_login.usuario)
                window.location.replace('/');
            }else{
                Alerta_Usuario_F(true)
                Alerta_Usuario_Str_F('Usuario o Contraseña son incorrectos.')
                setInterval (function() {
                    Alerta_Usuario_F(false)
                }, 5000);
            }
            Enviar_Login_F(false)

        }

    } catch (error) {
        if(JSON.stringify(error).split('"')[3] === "Network Error"){
            Alerta_Usuario_Str_F('Error interno, comunicarse con el proveedor.')
            Alerta_Usuario_F(true)
            setInterval (function() {
                Alerta_Usuario_F(false)
            }, 5000);
            Enviar_Login_F(false)
            return;
        }

        if(error.response.status === 401){
            Alerta_Usuario_F(true)
            Alerta_Usuario_Str_F('Usuario o Contraseña son incorrectos.')
            setInterval (function() {
                Alerta_Usuario_F(false)
            }, 5000);
            Enviar_Login_F(false)
        }else if(error.response.status === 500){
            Alerta_Usuario_Str_F('Error interno, comunicarse con el proveedor.')
            Alerta_Usuario_F(true)
            setInterval (function() {
                Alerta_Usuario_F(false)
            }, 5000);
            Enviar_Login_F(false)
        }
    }
}

    if(state.enviar_login){

        EnviarLogin();  
    }

    //eslint-disable-next-line
}, [ state.enviar_login]);

//RECUPERAR CLAVE
useEffect(() => {

    const RecuperarClave = async () => {

    try {
        
        const url = process.env.REACT_APP_LOCAL+'credenciales/recuperar/'+state.correo_recuperar.usuario+'/';
        const respuesta = await axios.get(url);


        if(respuesta.status === 200){
            Alerta_Recuperar_F(true)
            Alerta_Str_F('Se envió un correo con su contraseña.')    
        }else if(respuesta.status === 204){
            Alerta_Recuperar_F(true)
            Alerta_Str_F('El usuario no existe.')    
        }
        Enviar_Recuperar_F(false)
        
    } catch (error) {

        if(JSON.stringify(error).split('"')[3] === "Network Error"){
            Alerta_Modificar_Str_F('Error interno, comunicarse con el proveedor.')
            Alerta_Recuperar_F(true)
            setInterval (function() {
                Alerta_Recuperar_F(false)
            }, 5000);
            Enviar_Recuperar_F(false)
            return;
        }

        if(error.response.status === 500){
            Alerta_Modificar_Str_F('Error interno, comunicarse con el proveedor.')
            Alerta_Recuperar_F(true)
            setInterval (function() {
                Alerta_Recuperar_F(false)
            }, 5000);
            Enviar_Recuperar_F(false)
        }
        
    }
    }

    if(state.enviar_recuperar){

        RecuperarClave();  
    }

    //eslint-disable-next-line
}, [ state.enviar_recuperar]);

//MODIFICAR CONTRASEÑA

useEffect(() => {

    const dataForm = new FormData();
    dataForm.append('old_password', state.datos_modificar.old_password);
    dataForm.append('new_password', state.datos_modificar.new_password);
    dataForm.append('new_password2', state.datos_modificar.new_password2);
    dataForm.append('usuario', usuario);
    
    const ModificarClave = async () => {

        try {
            
        const urlogin = process.env.REACT_APP_LOCAL+'credenciales/modificar/'
        const respuesta = await axios.post(urlogin, dataForm,{
            headers: { 
                Authorization: "Bearer " + token_access,
                accept: 'application/json', }
        });

        if(respuesta.status === 200){
            Alerta_Modificar_F(true)
            Alerta_Modificar_Str_F("Se cambio la contraseña correctamente y se notificó vía correo electrónico.")
            Alerta_Modificar_Class_F("alert alert-success col-12 col-md-5 text-center my-2")
        }else if(respuesta.status === 204){
            Alerta_Modificar_F(true)
            Alerta_Modificar_Str_F("La contraseña actual no es correcta.")
            Alerta_Modificar_Class_F("alert alert-warning col-12 col-md-5 text-center my-2")
        }

        Enviar_Modificar_F(false)


        } catch (error) {
            if(JSON.stringify(error).split('"')[3] === "Network Error"){
                Alerta_Modificar_Str_F('Error interno, comunicarse con el proveedor.')
                Alerta_Modificar_F(true)
                setInterval (function() {
                    Alerta_Modificar_F(false)
                }, 5000);
                Enviar_Modificar_F(false)
                return;
            }

            if(error.response.status === 500){
                Alerta_Modificar_Str_F('Error interno, comunicarse con el proveedor.')
                Alerta_Modificar_F(true)
                setInterval (function() {
                    Alerta_Modificar_F(false)
                }, 5000);
                Enviar_Modificar_F(false)
            }
        }
    }

    if(state.enviar_modificar){
        ModificarClave();
    }

    //eslint-disable-next-line
}, [ state.enviar_modificar]);


    return(
        
        
        <CredencialesContext.Provider
            value={{
                datos_login: state.datos_login,
                alerta_usuario: state.alerta_usuario,
                correo_recuperar: state.correo_recuperar,
                alerta_recuperar: state.alerta_recuperar,
                alerta_recuperar_str: state.alerta_recuperar_str,
                enviar_recuperar: state.enviar_recuperar,
                datos_modificar: state.datos_modificar,
                alerta_modificar: state.alerta_modificar,
                alerta_modificar_str: state.alerta_modificar_str,
                alerta_modificar_class: state.alerta_modificar_class,
                enviar_login: state.enviar_login,
                alerta_usuario_str: state.alerta_usuario_str,
                Datos_Modificar_F,
                Enviar_Modificar_F,
                Datos_Login_F,
                Enviar_Login_F,
                Correo_Recuperar_F,
                Enviar_Recuperar_F,
                Alerta_Recuperar_F,
                Alerta_Str_F,
                Alerta_Modificar_F,
                Alerta_Modificar_Str_F,
                Alerta_Modificar_Class_F,
                Alerta_Usuario_Str_F
            }}

            


        >

            {props.children}
        </CredencialesContext.Provider>

    )
}

export default CredencialesState;